/* VSKLO PDP video markup bootstrap.
 *
 * Responsibility is intentionally narrow: insert inert Shopify video templates
 * and the lightbox player host before the DOMContentLoaded gallery owner starts.
 * It preserves the Shopify media position while mounting markup; variants,
 * navigation, playback and lightbox behavior belong only to
 * assets/vsklo-gallery-variant-filter.js.
 */
(function () {
  'use strict';

  if (window.__VSKLO_PDP_VIDEO_BOOTSTRAP_V5__) return;
  window.__VSKLO_PDP_VIDEO_BOOTSTRAP_V5__ = true;

  function positionOf(template) {
    var value = parseInt(template && template.dataset ? template.dataset.vskloMediaPosition : '', 10);
    return isFinite(value) && value > 0 ? value : Number.MAX_SAFE_INTEGER;
  }

  function insertFallbackAtPosition(root, node, position) {
    var fallbackItems = Array.prototype.filter.call(root.children, function (child) {
      return child.hasAttribute && child.hasAttribute('data-vsklo-fallback-media');
    });
    var index = position === Number.MAX_SAFE_INTEGER
      ? fallbackItems.length
      : Math.max(0, Math.min(fallbackItems.length, position - 1));
    var before = fallbackItems[index] || Array.prototype.find.call(root.children, function (child) {
      return child.hasAttribute && child.hasAttribute('data-vsklo-variant-id') && !child.hasAttribute('data-vsklo-shared-media');
    });

    if (before) root.insertBefore(node, before);
    else root.appendChild(node);
  }

  function ensureLightboxMarkup(gallery) {
    var lightbox = gallery.querySelector('[data-vsklo-lightbox]');
    if (!lightbox) return;

    var mediaWrap = lightbox.querySelector('.vsklo-product-lightbox__image-wrap');
    if (!mediaWrap) return;

    mediaWrap.setAttribute('data-vsklo-lightbox-media-wrap', '');

    if (!mediaWrap.querySelector('[data-vsklo-lightbox-player-host]')) {
      var host = document.createElement('div');
      host.className = 'vsklo-product-lightbox__player-host';
      host.setAttribute('data-vsklo-lightbox-player-host', '');
      host.hidden = true;
      mediaWrap.appendChild(host);
    }
  }

  function mountGallery(gallery) {
    if (!gallery || gallery.dataset.vskloPdpVideoMounted === 'true') return;

    var slidesRoot = gallery.querySelector('.vsklo-native-look-gallery__slides');
    var thumbsRoot = gallery.querySelector('[data-vsklo-thumbs]');
    var slideTemplates = Array.prototype.slice.call(
      document.querySelectorAll('template[data-vsklo-pdp-video-slide-template]')
    ).sort(function (a, b) {
      return positionOf(a) - positionOf(b);
    });

    ensureLightboxMarkup(gallery);

    if (!slidesRoot || !thumbsRoot || !slideTemplates.length) {
      gallery.dataset.vskloPdpVideoMounted = 'true';
      return;
    }

    slideTemplates.forEach(function (slideTemplate) {
      var mediaId = slideTemplate.dataset.vskloMediaId || '';
      var mediaType = slideTemplate.dataset.vskloMediaType || 'video';
      var mediaPosition = positionOf(slideTemplate);
      if (!mediaId || gallery.querySelector('[data-vsklo-slide][data-vsklo-media-id="' + mediaId + '"]')) return;

      var slide = document.createElement('div');
      slide.className = 'vsklo-native-look-gallery__slide is-hidden vsklo-native-look-gallery__slide--video';
      slide.setAttribute('data-vsklo-slide', '');
      slide.setAttribute('data-vsklo-fallback-media', '');
      slide.setAttribute('data-vsklo-shared-media', '');
      slide.setAttribute('data-vsklo-media-id', mediaId);
      slide.setAttribute('data-vsklo-media-type', mediaType);
      if (mediaPosition !== Number.MAX_SAFE_INTEGER) {
        slide.setAttribute('data-vsklo-media-position', String(mediaPosition));
      }
      slide.hidden = true;
      slide.appendChild(slideTemplate.content.cloneNode(true));
      insertFallbackAtPosition(slidesRoot, slide, mediaPosition);

      var thumbTemplate = document.querySelector(
        'template[data-vsklo-pdp-video-thumb-template][data-vsklo-media-id="' + mediaId + '"]'
      );
      if (!thumbTemplate) return;

      var thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'vsklo-native-look-gallery__thumb vsklo-native-look-gallery__thumb--video';
      thumb.setAttribute('data-vsklo-thumb', '');
      thumb.setAttribute('data-vsklo-fallback-media', '');
      thumb.setAttribute('data-vsklo-shared-media', '');
      thumb.setAttribute('data-vsklo-media-id', mediaId);
      thumb.setAttribute('data-vsklo-media-type', mediaType);
      if (mediaPosition !== Number.MAX_SAFE_INTEGER) {
        thumb.setAttribute('data-vsklo-media-position', String(mediaPosition));
      }
      thumb.setAttribute('aria-label', 'Show video');
      thumb.hidden = true;
      thumb.appendChild(thumbTemplate.content.cloneNode(true));
      insertFallbackAtPosition(thumbsRoot, thumb, mediaPosition);
    });

    gallery.dataset.vskloPdpVideoMounted = 'true';
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    if (root.nodeType === 1 && root.matches && root.matches('[data-vsklo-gallery]')) {
      mountGallery(root);
    }
    root.querySelectorAll('[data-vsklo-gallery]').forEach(mountGallery);
  }

  window.VSKLOMountPDPGalleryVideos = init;

  init(document);
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();